export const PLAYER_APK_RELEASE = '1.0.4';

const NEW_PLAYER_APK_DOMAINS = Object.freeze({
  'bullsplays.com': 'bullsplay',
  'finanreelplays.com': 'finandreels',
  'tideoraplay.com': 'tideoraplay',
  'havelockwins.com': 'havelockwins',
});

export const playerApkPath = (
  tenantSlug,
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
) => {
  // The tenant-owned host wins over stale or generic route/database slugs.
  // Never infer an app from ambiguous slugs such as "play" or "plays".
  const host = String(hostname || '').trim().toLowerCase().replace(/\.$/, '').replace(/^www\./, '');
  const requested = String(tenantSlug || '').trim();
  const slug = NEW_PLAYER_APK_DOMAINS[host]
    || NEW_PLAYER_APK_DOMAINS[requested.toLowerCase().replace(/^www\./, '')]
    || requested;
  if (!slug) return '';
  return `/uploads/player-apks/${encodeURIComponent(slug)}.apk?v=${encodeURIComponent(PLAYER_APK_RELEASE)}`;
};

export const getNativePlayerBridge = () => {
  if (typeof window === 'undefined') return null;
  return window.AndroidPlayerApp || window.TeamLobbyAndroid || window.PlayEmpAndroid || null;
};

export const isNativePlayerRuntime = () => Boolean(getNativePlayerBridge());

const versionParts = (version) => {
  const value = String(version || '').trim();
  if (!/^\d+(?:\.\d+)*$/.test(value)) return null;
  return value.split('.').map(part => Number(part));
};

export const comparePlayerApkVersions = (left, right) => {
  const leftParts = versionParts(left);
  const rightParts = versionParts(right);
  if (!leftParts || !rightParts) return null;

  const length = Math.max(leftParts.length, rightParts.length);
  for (let index = 0; index < length; index += 1) {
    const leftPart = leftParts[index] || 0;
    const rightPart = rightParts[index] || 0;
    if (leftPart < rightPart) return -1;
    if (leftPart > rightPart) return 1;
  }
  return 0;
};

export const getNativePlayerAppVersion = (bridge = getNativePlayerBridge()) => {
  if (!bridge || typeof bridge.getAppVersion !== 'function') return '';
  try {
    return String(bridge.getAppVersion() || '').trim();
  } catch {
    return '';
  }
};

export const shouldPromptPlayerApkUpdate = ({
  bridge = getNativePlayerBridge(),
  latestVersion = PLAYER_APK_RELEASE,
} = {}) => {
  if (!bridge) return false;
  const currentVersion = getNativePlayerAppVersion(bridge);
  if (!currentVersion) return true;
  const comparison = comparePlayerApkVersions(currentVersion, latestVersion);
  return comparison === null || comparison < 0;
};
